import type { FunctionComponent } from 'react';

import { Link } from '@dr.pogodin/react-utils';

import Avatar from 'components/Avatar';

import { useProfileHeroImage } from 'hooks';

import {
  E_FILE,
  P_API_ASSETS,
  type PublicUserDataT,
  type UserT,
  getUserDisplayName,
} from 'utils';

import './style.scss';

type PropsT = {
  artistId?: string;

  // BEWARE: For now, it deliberately only inactivates the link, but does not
  // change the component's visual appearance. If you are ever to change it,
  // mind, there are existing components relying on this one, that want
  // the click on this component to do nothing, but the component itself
  // to have a regular appearance!!!
  disabled?: boolean;

  to: string;
  user: PublicUserDataT | UserT;
};

/**
 * Renders a combination of the given user's avatar and name,
 * which acts as a link to the specified page.
 */
export const UserLink: FunctionComponent<PropsT> = ({
  artistId, disabled, to, user,
}) => {
  const { data: heroImage } = useProfileHeroImage(artistId ?? '');
  const photoUrl = heroImage
    ? `${P_API_ASSETS}/${heroImage.id}${E_FILE}?s=120`
    : undefined;

  const email = 'email' in user ? user.email : undefined;

  return (
    <Link disabled={disabled} styleName="container" to={to}>
      <Avatar photoUrl={photoUrl} user={user} />
      <div>
        <div>{getUserDisplayName(user)}</div>
        {email ? <div styleName="email">{email}</div> : null}
      </div>
    </Link>
  );
};
